import styled from "styled-components";
import { Link as LinkS } from "react-scroll";
import { Link as LinkR } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import { theme } from "../../theme/theme";

export const SidebarContainer = styled.aside`
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: #0d0d0d;
  display: grid;
  align-items: center;
  top: 0;
  left: 0;
  transition: 0.3 ease-in-out;
  opacity: ${({ isOpen }: { isOpen: boolean }) => (isOpen ? "100%" : "0")};
  top: ${({ isOpen }: { isOpen: boolean }) => (isOpen ? "0" : "-100%")};
  display: none;
  @media screen and (max-width: 1000px) {
    display: block;
  }
`;

export const CloseIcon = styled(FaTimes)`
  color: ${theme.pallete.surface.white};
`;

export const Icon = styled.div`
  position: absolute;
  top: 1.2rem;
  right: 1.5rem;
  background: transparent;
  font-size: 2rem;
  cursor: pointer;
  outline: none;
`;

export const SidebarWrapper = styled.div`
  color: ${theme.pallete.surface.white};
  margin-top: 60px;
`;

export const SidebarMenu = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(6, 80px);
  text-align: center;

  @media screen and (max-width: 480px) {
    grid-template-rows: repeat (6, 60px);
  }
`;

export const LogoMenu = styled.ul`
  text-align: center;
`;

export const SidebarLinkS = styled(LinkS)`
  display: FaFileExcel;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: ${theme.pallete.surface.white};
  cursor: pointer;

  &:hover {
    color: ${theme.pallete.accent.main};
    transition: 0.2s ease-in-out;
  }
`;

export const SidebarLinkR = styled(LinkR)`
  display: FaFileExcel;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: ${theme.pallete.surface.white};
  cursor: pointer;

  &:hover {
    color: ${theme.pallete.accent.main};
    transition: 0.2s ease-in-out;
  }
`;

export const SideBtnWrap = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 30px;
`;

export const SidebarRoute = styled(LinkR)`
  border-radius: 50px;
  background: ${theme.pallete.primary.main};
  white-space: nowrap;

  color: ${theme.pallete.surface.white};
  padding: 16px 64px;
  font-weight: normal;
  letter-spacing: 0.4px;
  font-size: 1rem;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2 ease-in-out;
    background: #270042;
    color: ${theme.pallete.surface.white};
  }
`;
